import {
  ModelSelect, ModelTextarea,
  ModelType,
  FlexColumn,
  InputRow,
  EmptyInput,
  UserRoles,
} from '@equifinance/shared';
import { useEffect } from 'react';
import styled from 'styled-components';
import {
  useChecklistContext,
  PolicyShieldsDecision,
} from '../../../../../../contexts';
import {
  Label, SelectWrapper,
  UnderwriterDecisionForm,
  UnderwriterDecisionTitle,
} from '../../../../components/UnderwriterDecision';
import { useUsersByPermissionTypes } from '../../../../../../hooks/useInternalUsers';

const Container = styled(FlexColumn)``;

export function PolicyShieldUnderwriterDecision() {
  const { internalUsers, fetchInternalUsers } = useUsersByPermissionTypes(UserRoles.CAN_APPROVE_POLICY_SHIELD_OVERRIDES);
  const {
    id, updateChecklist, checklist,
  } = useChecklistContext();

  const { policyShields } = checklist ?? {};
  const { decision } = policyShields ?? {};

  const path = 'policyShields';

  const underwriterOptions: Record<string, string> = internalUsers
    .reduce((prev, current) => ({
      ...prev,
      ...(current.isActive ? { [current.id]: current.displayName } : {}),
    }), {});

  const onChangeAuthorisedByName = (model: ModelType) => {
    const authorisedById = model[`${path}.authorisedById`];
    const authorisedByName = underwriterOptions[authorisedById];

    updateChecklist(`${path}.authorisedById`, authorisedById);
    updateChecklist(`${path}.authorisedByName`, authorisedByName);
  };

  useEffect(() => {
    fetchInternalUsers();
  }, [id]);

  const autoApprovedDecision = decision === 'AutoApproved';
  const rejectedDecision = decision === PolicyShieldsDecision.Rejected;
  const decisionOptions = {
    Approved: PolicyShieldsDecision.Approved,
    Rejected: PolicyShieldsDecision.Rejected,
  };

  return (
    <Container>
      <UnderwriterDecisionTitle>
        <Label>{'Underwriter\'s decision'}</Label>
        <SelectWrapper>
          <ModelSelect
            placeholder="Please select"
            field={`${path}.decision`}
            options={autoApprovedDecision ? PolicyShieldsDecision : decisionOptions}
            disabled={autoApprovedDecision}
          />
        </SelectWrapper>
      </UnderwriterDecisionTitle>

      {!autoApprovedDecision && (
        <UnderwriterDecisionForm>
          <InputRow>
            <ModelTextarea
              field={`${path}.justification`}
              label="Justification"
              required
              rows={3}
            />
          </InputRow>
          {!rejectedDecision && (
            <InputRow>
              <ModelSelect
                label="Authorised by"
                field={`${path}.authorisedById`}
                placeholder="Please select"
                options={underwriterOptions}
                updateOverride={onChangeAuthorisedByName}
                required
              />
              <EmptyInput />
            </InputRow>
          )}
        </UnderwriterDecisionForm>
      )}
    </Container>
  );
}
